/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserResponseList {
    getFixupPrototypeFunction() { return UserResponseList.fixupPrototype; }

    static newInstance(model: Partial<UserResponseList>): UserResponseList {
        let obj = Object.assign(new UserResponseList(), model);
        UserResponseList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserResponseList>): UserResponseList {
        if (!model) return null;
        return UserResponseList.newInstance(<UserResponseList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserResponseList) {
        if (!obj) return;

        models.UserResponseList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserResponseList): boolean {
        Object.setPrototypeOf(obj, UserResponseList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.users) {
            for (let val of this.users) {
                models.UserDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Number of users in CoreStack account.
     */
    total_count: number;

    /**
     * List all users within a CoreStack account.
     */
    users: Array<models.UserDetails>;

}
